import moment from "dayjs";
import { useCallback } from "react";

import { usePersistedState } from "hooks";
import { entities } from "reduxStore";

import { EditedJob, BackendJob } from "components/EditJob";

const sortJobs = (job1: BackendJob, job2: BackendJob) => {
    if (job1.status !== job2.status) {
        return ((job2.status as number) - (job1.status as number)) || 0
    } else {
        return moment(job1.createdOn).diff(moment(job2.createdOn))
    }
}

export const getJobsByTab = (jobs: BackendJob[]) => {
    const now = new Date();
    return {
        active: (
            jobs
                .filter(job => {
                    return (job.status === 1 || job.status === 0) && job.expires !== null && job.expires !== undefined && new Date(job.expires) > now;
                })
                .sort((a: BackendJob, b: BackendJob) => (b.status as number) - (a.status as number)) || []
        ).sort(sortJobs),
        inactive: (
            jobs.filter(job => {
                return job.status === 2 || job.status === 3 || job.expires === null || job.expires === undefined || new Date(job.expires) <= now;
            }) || []
        ).sort(sortJobs)
    }
}

export const useClearJobPost = (defaultNotificationEmail: string) => {
    const savePostJob = usePersistedState<EditedJob>
    ({
        entityName: entities.editedJobPost,
        initialValue: undefined,
    })[1]
    return useCallback(() => {
        savePostJob({
            notificationEmail: defaultNotificationEmail,
            isPublic: false,
        })
    }, [savePostJob, defaultNotificationEmail])
}
